import "./styles.css";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router";
import { name, version } from "../package.json";
import { MapPage } from "./pages/MapPage";
import { PayloadViewer } from "./pages/PayloadViewer";

console.log(`${name} ${version}`);

const rootElement = document.getElementById("root");

if (rootElement === null) {
	throw new Error("Failed to find the root element");
}

const basename = import.meta.env.PROD ? new URL("..", import.meta.url).pathname : "/";

const router = createBrowserRouter(
	[
		{
			path: "/",
			element: <MapPage />,
		},
		{
			path: "/payload-viewer",
			element: <PayloadViewer />,
		},
	],
	{ basename },
);

createRoot(rootElement).render(
	<StrictMode>
		<RouterProvider router={router} />
	</StrictMode>,
);
